/**
 * Route guard — replaces the `requireAuth` middleware pattern from Flutter
 * GoRouter `redirect` callback. If the user isn't logged in we send them
 * to /login; if they are but haven't picked a mode yet we send them to
 * /mode-selector. Bootstrap state must finish before any decision.
 */
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useModeStore } from '@/stores/modeStore';

interface Props {
  children: ReactNode;
  requireMode?: boolean;
}

export function ProtectedRoute({ children, requireMode = true }: Props) {
  const { user, initialized } = useAuthStore();
  const { mode } = useModeStore();
  const location = useLocation();

  if (!initialized) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-text-secondary animate-pulse">…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (requireMode && !mode) {
    return <Navigate to="/mode-selector" replace />;
  }
  return <>{children}</>;
}
